import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { CodeTaskService } from '../code-task.service';
import { CodeTask } from '../code-task';
import { CodeProjectService } from '@app/_components/code-project/code-project.service';


@Component({
    selector: 'app-code-task',
    templateUrl: './code-task.component.html',
    styleUrls: ['./code-task.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class CodeTaskComponent implements OnInit {
    categories: any;
    priorities: any;
    codeProjectId: any;
	codeProjectIdRequired = false
	codeProjects: any;
    employees: any;

	constructor(
		private codeProjectService: CodeProjectService,
		private primengConfig: PrimeNGConfig,
		private codeTaskService: CodeTaskService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
			this.codeProjectId = data.codeProjectId,
			this.formTitle = data.title,
			this.codeTask = data.codeTask,
			this.statuses = codeTaskService.statuses;
			this.categories = codeTaskService.categories;
			this.priorities = codeTaskService.priorities;
			this.employees = codeTaskService.employees;
			
	}

	@Input() codeTask: CodeTask;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	codeTaskId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'codeTaskId': [],
		'taskName': [
			{ type: 'required', message: 'Required' },
			{ type: 'minlength', message: '5 characters minimum' }],
		'taskDesc': [],
		'category': [],
		'status': [],
		'priority': [],
		'comments': [],
		'assignedTo': [],
		'assignedDate': [],
		'completedDate': [],
		'hours':[],
		'codeProjectId': [],
	};
	
	ngOnInit() {
		this.fetchCodeProjects();
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole codeTask object
		if (this.codeTask) {
			this.codeTaskId = this.codeTask.codeTaskId;
			if(this.codeTask.assignedDate != undefined && this.codeTask.assignedDate != null){
				this.codeTask.assignedDate = moment.utc(this.codeTask.assignedDate).format('MM/DD/YYYY');
			}
			if(this.codeTask.completedDate != undefined && this.codeTask.completedDate != null){
				this.codeTask.completedDate = moment.utc(this.codeTask.completedDate).format('MM/DD/YYYY');
			}
			this.fixDates();
			this.form1.patchValue(this.codeTask);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.codeTaskId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			
			//if(this.form1.value.guestRefundId == null && this.form1.value.guestRefundId == undefined && this.form1.value.guestRefundId == "undefined"){
				this.form1.value.codeProjectId = this.codeProjectId;
			//}
			/*if(this.form1.value.guestRefundId == null){
				this.guestRefundIdRequired = true;
				this.messageService.add({ severity: 'error', summary: 'Validation Error', detail: "Guest refund is required" });
				return;
			}*/
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.codeTaskService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.codeTask = res.data.codeTask;
						this.doAdd.emit(this.codeTask);
					},
					(err: any) => {
						console.log('codeTask-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('codeTask: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;
			console.log("this.form1.value.assignedDate :"+this.form1.value.assignedDate);
			this.form1.value.assignedDate = moment.utc(this.form1.value.assignedDate);
			this.codeTaskService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.codeTask = res.data.codeTask;
						this.doUpdate.emit(this.codeTask);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.codeTaskService.delete(this.codeTask.codeTaskId)
				.subscribe(
					(res: any) => {
						console.log('codeTask-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.codeTask);
					},
					(err: any) => {
						console.log('codeTask-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			codeTaskId: [this.codeTaskId],
			taskName: ['', Validators.compose(
				[
					Validators.minLength(5),
					Validators.required
				])],
			taskDesc: [],
			category: ['task'],
			status: ['open'],
			priority: ['low'],
			comments: [],
			assignedTo: [],
			assignedDate: [moment().toDate()],
			completedDate: [],
			hours: [],
			codeProjectId: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.codeTask.codeTaskDate = moment.utc(this.codeTask.codeTaskDate).format('MM/DD/YYYY');
	}
	
	fetchCodeProjects() {
		if (!this.codeProjects || this.codeProjects === undefined || this.codeProjects.length < 1) {
			try {
				this.codeProjectService.findAll()
					.subscribe(
						res => {
							console.log('findAllActivityProvidersSummary: ' + JSON.stringify(res));
							this.codeProjects = res.data.codeProjects;
							return this.codeProjects;
						},
						err => {
							console.log('Feature-Update FAIL: ' + JSON.stringify(err));
							this.alertService.error(err);
						},
						() => { });
			} catch (error) {
				console.log('Form Invalid: ' + JSON.stringify(error));
				this.alertService.error(error);
			}
		}
		else {
			// console.log('properties are ' + this.properties);
			return (this.codeProjects);
		}
	}
	
	selectCodeProject(){
		this.codeProjectIdRequired = false;
	}
	
}
